import React, { useEffect } from 'react';
import '../Styles/Contact.css';
import AppHeader from '../Layout/Header';
import FooterComponent from '../Layout/Footer';
import GetInTouch from '../Components/ContactComponent/GetInTouch';
import MapComponent from '../Components/ContactComponent/MapComponent';
import FooterQuote from '../Layout/FooterQuote';

const Contact = () => {
    useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant',
    });
  }, []);
  return (
    <>
      <AppHeader />
      <div className="contact-page">
        <div className="contact-bg-container" role="img" aria-label="Contact NCGSA" />
        <main className="page-content-bands">
          <section><GetInTouch /></section>
          <section><MapComponent /></section>
        </main>
      </div>
      <FooterQuote
        variant="contact"
        quote="It is He who placed for you the stars that you may be guided by them through the darknesses of the land and sea."
        attribution="Qur’an 6:97"
      />
      <FooterComponent />
    </>
  );
};

export default Contact;
